export default __webpack_public_path__ + "static/media/textures.ff414cf8.png";